export default {
  registerUrl: '/security/signup',
  loginUrl: '/security/login',
  logoutUrl: '/security/logout',
  isSessionActive: '/security/isLoggedIn',
  forgotPassword: '/security/forgotPassword?email=',
  validateResetToken: '/security/validatePasswordResetToken/',
  resetPassword: '/security/resetPassword',

  searchProduct: '/catalog/search',
  confirmEmail: '/security/confirmEmailAddress',
  resendEmail: '/security/resendEmailAddressConfirmationLink?email=',

  // Shopping cart
  addToCart: '/shopping/addToCart',
  getCart: '/shopping/getCart',
  deleteCart: '/shopping/deleteFromCart',
  updateCart: '/shopping/updateCart',

  // Admin Panel
  listCatalog: '/catalog/search',
  deleteProduct: '/catalog/deleteProduct',
  addProduct: '/catalog/addProduct',
  refData: '/referenceData/getCatalogBundle',
  getProduct: '/catalog/getProductDetails',
  editProduct: '/catalog/updateProduct',
  updateProductData: '/catalog/updateProductData',
  aiGenerateProductDescription: '/v2/admin/ai/products/:productId/description',

  // User settings
  roles: '/referenceData/getRoles',
  allAdmins: '/superAdmin/getAllAdmins',
  addAdmin: '/superAdmin/createAdmin',
  deleteAdmin: '/superAdmin/deleteAdmin',
  editAdmin: '/superAdmin/updateAdminAccess',
  predefinedUrls: '/catalog/getPresignedUrlsForCatalogImageUploads',

  // Order URLS
  getOrderByStatus: '/orders/orderList',
  getSingleOrderById: '/orders/order?orderId=',
  getCheckouts: '/checkouts',
  getCheckoutById: '/checkouts/',
  confirmOrder: '/orders/confirmOrder',
  fulfillOrder: '/orders/markItemAsFulfilling',
  editFulfillOrder: '/orders/updateOrderFulfillmentDetails',
  markShipped: '/orders/markItemAsShipped',
  editShipped: '/orders/updateShipmentDetails',
  markDelivered: '/orders/markItemAsDelivered',
  editDelivered: '/orders/updateDeliveryDetails',
  cancelOrder: '/orders/cancelOrder',
  updateOrderStatus: '/orders/:orderId/status',
  deleteCheckoutById: '/checkouts/:checkoutId',
  sendCommercialEmail: '/checkouts/:checkoutId/email',

  // Tariff URLs
  allTariffs: '/referenceData/tariffList',
  editTariff: '/referenceData/tariff',
  addTariff: '/referenceData/tariff',

  // Comments
  postComment: '/orders/addComment',
  deleteComment: '/orders/deleteComment',
  putComment: '/orders/editComment',


  // Categories
  allCategories: '/referenceData/productCategoryList',
  editCategory: '/referenceData/productCategory/{id}',
  addCategory: '/referenceData/productCategory',

  // Featured
  getAllFeatures: '/ui/featuredList',
  featuredUrl: '/ui/featured',

  // Brand URLs
  allBrands: '/referenceData/brands',
  editBrand: '/referenceData/brands',
  addBrand: '/referenceData/brands',

  // Provider URLs
  allProviders: '/referenceData/providers',
  editProvider: '/referenceData/providers',
  addProvider: '/referenceData/providers',

  // Inventory URLs
  allInventorys: '/inventory/movements',
  //editInventory: '/inventory',
  addInventory: '/inventory/movements',
  allInventoryByCatalog: '/inventory/catalog',
  downloadInventory: '/inventory/movements/:fileFormat',
  deleteInventory: '/inventory/movements/:id',
};
